export * from './quick-stake'